/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";

/**
 * This is a very simple utility module to ensure that Django and Underscore
 * escaped strings use the same HTML entities when being escaped/unescaped.
 *
 * i.e.
 *      &#x27; === &#39; === single quote
 */
export default {
    /**
     * Escapes the provided string by replacing Underscore's
     * HTML entities with the ones used by Django.
     *
     * @params {String} string
     * @returns {String}
     */
    escape(string) {
        if (!_.isString(string)) {
            console.error("The argument provided is not a string.");
            return;
        }

        let escapedString = string.replace(/&#x27;/g, "&#39;");
        return _.escape(escapedString);
    },

    /**
     * Unescapes the provided string by replacing Django's
     * HTML entities with the ones used by Underscore.
     *
     * @params {String} string
     * @returns {String}
     */
    unescape(string) {
        if (!_.isString(string)) {
            console.error("The argument provided is not a string.");
            return;
        }

        let unescapedString = string.replace(/&#39;/g, "&#x27;");
        return _.unescape(unescapedString);
    },

    /**
     * Capitalizes the first letter for the provided string.
     *
     * @params {String} string
     * @returns {String}
     */
    capitalize(string) {
        if (!_.isString(string)) {
            console.error("The argument provided is not a string.");
            return;
        }

        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    /**
     * Strips HTML tags and converts HTML entities like "&amp;" into their equivalent characters.
     * @param {string} string
     * @returns {string}
     */
    stripHTML(string) {
        var el = document.createElement("div");
        el.innerHTML = string;
        return el.textContent;
    }
};

